var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          staticClass: "section top",
          staticStyle: { "flex-direction": "row", "min-width": "1600px" },
          attrs: { disabled: _vm.readonly }
        },
        [
          _c(
            "el-checkbox",
            {
              attrs: { no: "1" },
              on: {
                change: function($event) {
                  return _vm.loadingTerm_Change("warehousing")
                }
              },
              model: {
                value: _vm.job.warehousing,
                callback: function($$v) {
                  _vm.$set(_vm.job, "warehousing", $$v)
                },
                expression: "job.warehousing"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Storage")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "2" },
              model: {
                value: _vm.job.comercialInspectation,
                callback: function($$v) {
                  _vm.$set(_vm.job, "comercialInspectation", $$v)
                },
                expression: "job.comercialInspectation"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CommodityInspection")))]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section top", staticStyle: { "min-width": "1600px" } },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BasicInfo")))
          ]),
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "100px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessNo") } },
                [
                  _c("el-input", {
                    staticClass: "job-no-color",
                    attrs: { no: "3", disabled: true },
                    model: {
                      value: _vm.job.jobNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "jobNo", $$v)
                      },
                      expression: "job.jobNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_WarehouseNo") } },
                [
                  _c("el-input", {
                    attrs: { no: "4" },
                    model: {
                      value: _vm.job.warehouseNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "warehouseNo", $$v)
                      },
                      expression: "job.warehouseNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.quotationNum") } },
                [
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: {
                      no: "5",
                      value: _vm.job.quotationNo,
                      disabled: true
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Payment.businessReferenceNumber") } },
                [
                  _c("cargo-input", {
                    attrs: { no: "6", trim: true },
                    model: {
                      value: _vm.job.customerRefNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "customerRefNo", $$v)
                      },
                      expression: "job.customerRefNo"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", [
            _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Payment.consignationCompany"))
                            )
                          ]
                        ),
                        _vm.accountObjectControlMode === 2
                          ? _c("cargo-sales-company-select", {
                              attrs: {
                                no: "7",
                                disabled: !(
                                  !_vm.job.mbl && _vm.electricBusinessBtnEnable
                                ),
                                "method-params": {
                                  customer: true,
                                  active: true
                                },
                                "check-credit": true,
                                job: _vm.job,
                                "default-value": _vm.job.customerId || "",
                                placeholder: _vm.$t("SeaExport.RequiredItem")
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.txtCustomerId_changeHandler(p)
                                  _vm.clearPoNo()
                                }
                              }
                            })
                          : _c("cargo-company-select", {
                              attrs: {
                                no: "7",
                                disabled: !(
                                  !_vm.job.mbl && _vm.electricBusinessBtnEnable
                                ),
                                "method-params": {
                                  customer: true,
                                  active: true
                                },
                                "check-credit": true,
                                job: _vm.job,
                                "default-value": _vm.job.customerId || "",
                                "static-options": _vm.customerCmpList,
                                placeholder: _vm.$t("SeaExport.RequiredItem")
                              },
                              on: {
                                change: function(p) {
                                  _vm.txtCustomerId_changeHandler(p)
                                  _vm.clearPoNo()
                                }
                              }
                            })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.contactPerson") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "8",
                              disabled: !_vm.electricBusinessBtnEnable,
                              filterable: "",
                              "allow-create": true,
                              placeholder: ""
                            },
                            on: { change: _vm.tfLinkman_closeHandler },
                            model: {
                              value: _vm.job.customerContact,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "customerContact", $$v)
                              },
                              expression: "job.customerContact"
                            }
                          },
                          _vm._l(_vm.contactList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.contactPerson,
                                value: item.contactPerson
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isShowContactPersonDetail,
                            expression: "!isShowContactPersonDetail"
                          }
                        ],
                        attrs: { label: _vm.$t("SeaExport.Tel") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "9",
                            disabled: !_vm.electricBusinessBtnEnable,
                            maxlength: "32"
                          },
                          model: {
                            value: _vm.job.contactTelephone,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "contactTelephone", $$v)
                            },
                            expression: "job.contactTelephone"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isShowContactPersonDetail,
                            expression: "!isShowContactPersonDetail"
                          }
                        ],
                        attrs: { label: _vm.$t("SeaExport.Fax") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "10",
                            disabled: !_vm.electricBusinessBtnEnable,
                            maxlength: "32"
                          },
                          model: {
                            value: _vm.job.contactFax,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "contactFax", $$v)
                            },
                            expression: "job.contactFax"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { staticClass: "blue" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("Payment.sales")))]
                        ),
                        _c("cargo-user-select", {
                          attrs: {
                            no: "11",
                            disabled:
                              _vm.lockSales ||
                              !(
                                !_vm.job.trustFromJob &&
                                _vm.electricBusinessBtnEnable &&
                                (!_vm.validateCustomerSales ||
                                  (_vm.isSpecifiedSalesBusiness &&
                                    _vm.validateCustomerSales))
                              ),
                            "method-params": {
                              officeId: _vm.salesOfficeCheck
                                ? _vm.$store.getters.currentOfficeId
                                : "",
                              category: "role",
                              shape: "sales"
                            },
                            "default-value": _vm.job.sales || "",
                            "static-options": _vm.salesList,
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: { change: _vm.txtSales_changeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "blue" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.SalesCompany")))]
                        ),
                        _c("el-input", {
                          attrs: {
                            no: "12",
                            disabled: true,
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          model: {
                            value: _vm.txtSalesOffice,
                            callback: function($$v) {
                              _vm.txtSalesOffice = $$v
                            },
                            expression: "txtSalesOffice"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.customerService") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "13",
                            disabled: Boolean(_vm.job.trustFromJob),
                            "method-params": {
                              category: "role",
                              shape: "csr",
                              officeId: _vm.job.opOffice
                            },
                            "default-value": _vm.job.csr || "",
                            "static-options":
                              _vm.userPortRoleData.csr || _vm.csrList,
                            placeholder: " "
                          },
                          on: { change: _vm.csrChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.OverseaCustomerService"),
                          "label-width": "100px"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "overseaOp",
                          staticClass: "input2",
                          attrs: {
                            no: "overseaOp",
                            placeholder: " ",
                            "default-value": _vm.job.overseaOp || "",
                            "method-params": {
                              category: "role",
                              shape: "overseaOp"
                            },
                            "static-options": _vm.isHc
                              ? null
                              : _vm.userPortRoleData.overseaOp ||
                                _vm.overseaAgentUsersList,
                            "merge-load": true
                          },
                          on: {
                            change: function(p) {
                              _vm.job.overseaOp = p.value
                              _vm.OverseaCustomerUtils.overseaOpChangeHandler(
                                _vm.view,
                                p
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.OperateType") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "14",
                            filterable: "",
                            "select-type":
                              _vm.TYPE_NAMES
                                .local_cache_AirExportConstants$BUSINESS_MODELS,
                            "default-value": _vm.job.operateType,
                            clearable: false
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.operateType = p.value
                              _vm.onOperateTypeChange()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("FileHistory.operation") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "15",
                            disabled: Boolean(_vm.job.trustFromJob),
                            "method-params": {
                              category: "role",
                              shape: "op",
                              officeId: _vm.$store.getters.currentOfficeId
                            },
                            "default-value": _vm.job.op || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.op
                          },
                          on: { change: _vm.txtOPChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("queryJob.operationDepartment") }
                      },
                      [
                        _c("cargo-department-select", {
                          attrs: {
                            no: "16",
                            disabled: Boolean(_vm.job.trustFromJob),
                            "office-id": _vm.job.opOffice,
                            "department-id": _vm.job.opDepartment,
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.job.opDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.OperationCompany") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "17",
                            disabled: _vm.isEntrustOrder(),
                            "select-type": _vm.TYPE_NAMES.basic_data_Office,
                            filterable: "",
                            "default-value": _vm.job.opOffice || "",
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.opOffice = p.value
                              _vm.opOfficeChargeHandler()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "18",
                            "method-params": {
                              category: "role",
                              shape: "salesOfGoods"
                            },
                            "default-value": _vm.job.cargoSalesId || "",
                            "static-options": _vm.cargoSalesList,
                            placeholder: " "
                          },
                          on: { change: _vm.cargoSalesChargeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("queryJob.Documents") } },
                      [
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "104",
                            disabled: Boolean(_vm.job.trustFromJob),
                            "method-params": {
                              category: "role",
                              shape: "doc",
                              officeId: _vm.$store.getters.currentOfficeId
                            },
                            "default-value": _vm.job.dc || "",
                            "static-options":
                              _vm.userPortRoleData.doc || _vm.dcList,
                            placeholder: " "
                          },
                          on: { change: _vm.dcChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.FieldOperation") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "19",
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId,
                              category: "role",
                              shape: "siteOp"
                            },
                            "default-value": _vm.job.siteOP || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.siteOp
                          },
                          on: {
                            change: function(p) {
                              _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.planner") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "20",
                            "method-params": {
                              category: "role",
                              shape: "airline",
                              officeId:
                                _vm.currentOffice.code === "HB"
                                  ? null
                                  : _vm.currentOffice.officeId
                            },
                            "default-value": _vm.job.planner || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.airline
                          },
                          on: { change: _vm.txtPlannerChangeHandler }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Message.Customer_Service") } },
                      [
                        _c("cargo-department-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "csrDepartment",
                            "office-id": Number(_vm.job.csrOffice),
                            enables: true,
                            "department-id": Number(_vm.job.csrDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.csrDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomerOffice") } },
                      [
                        _c("cargo-advance-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "csrOffice",
                            disabled: true,
                            "select-type": _vm.TYPE_NAMES.basic_data_Office,
                            filterable: "",
                            "default-value": _vm.job.csrOffice || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.csrOffice = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Message.Documentation_Department")
                        }
                      },
                      [
                        _c("cargo-department-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "dcDepartment",
                            "office-id": Number(_vm.job.dcOffice),
                            enables: true,
                            "department-id": Number(_vm.job.dcDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.dcDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.DocumentOffice") } },
                      [
                        _c("cargo-advance-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "dcOffice",
                            disabled: true,
                            "select-type": _vm.TYPE_NAMES.basic_data_Office,
                            filterable: "",
                            "default-value": _vm.job.dcOffice || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.dcOffice = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        class: _vm.poNoRed ? "poNoClass" : "",
                        attrs: { label: _vm.$t("Payment.itemNo") }
                      },
                      [
                        !_vm.openProjectConfig
                          ? _c("el-input", {
                              attrs: { no: "21" },
                              model: {
                                value: _vm.job.poNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "poNo", $$v)
                                },
                                expression: "job.poNo"
                              }
                            })
                          : _vm._e(),
                        _vm.openProjectConfig
                          ? _c("cargo-project-select", {
                              attrs: {
                                no: "22",
                                "default-value": _vm.job.poNo,
                                "customer-id": _vm.job.customerId,
                                "is-linked": _vm.isProjectLinkedCustomer
                              },
                              on: { change: _vm.changeProject }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.AirlineDepartment") }
                      },
                      [
                        _c("cargo-department-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "plannerDepartment",
                            "office-id": Number(_vm.job.plannerOffice),
                            enables: true,
                            "department-id": Number(_vm.job.plannerDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.plannerDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.AirlineOffice") } },
                      [
                        _c("cargo-advance-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "plannerOffice",
                            disabled: true,
                            "select-type": _vm.TYPE_NAMES.basic_data_Office,
                            filterable: "",
                            "default-value": _vm.job.plannerOffice || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.plannerOffice = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm.openProjectConfig
                      ? _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SeaExport.ProjectName") } },
                          [
                            _c("el-input", {
                              attrs: { no: "23", disabled: true },
                              model: {
                                value: _vm.job.projectName,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "projectName", $$v)
                                },
                                expression: "job.projectName"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.openProjectConfig
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.ProjectBatch") }
                          },
                          [
                            _c("el-input", {
                              attrs: { no: "24" },
                              model: {
                                value: _vm.job.projectBatch,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "projectBatch", $$v)
                                },
                                expression: "job.projectBatch"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm.isAddUserDefinedRoles
                  ? _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: _vm.readonly,
                          inline: true,
                          "label-width": "100px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                            }
                          },
                          [
                            _c("cargo-user-select", {
                              attrs: {
                                no: "25",
                                "method-params": {
                                  officeId: _vm.$store.getters.currentOfficeId,
                                  category: "role",
                                  shape: "userDefinedRole1"
                                },
                                "default-value":
                                  _vm.job.userDefinedRoleId1 || "",
                                placeholder: _vm.$t("SeaExport.RequiredItem"),
                                "static-options":
                                  _vm.userPortRoleData.userDefinedRole1
                              },
                              on: { change: _vm.userDefinedRoleId1Handler }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                            }
                          },
                          [
                            _c("cargo-user-select", {
                              attrs: {
                                no: "26",
                                "method-params": {
                                  officeId: _vm.$store.getters.currentOfficeId,
                                  category: "role",
                                  shape: "userDefinedRole2"
                                },
                                "default-value":
                                  _vm.job.userDefinedRoleId2 || "",
                                placeholder: _vm.$t("SeaExport.RequiredItem"),
                                "static-options":
                                  _vm.userPortRoleData.userDefinedRole2
                              },
                              on: { change: _vm.userDefinedRoleId2Handler }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.job.preverifyState === 3,
                    expression: "job.preverifyState===3"
                  }
                ],
                staticStyle: { display: "flex" }
              },
              [
                _c("span", { staticStyle: { width: "100px" } }, [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DenialReason")))
                ]),
                _c("el-input", {
                  staticStyle: { width: "260px" },
                  attrs: {
                    no: "27",
                    type: "textarea",
                    rows: 3,
                    disabled: true
                  },
                  model: {
                    value: _vm.job.bookingRefuseNote,
                    callback: function($$v) {
                      _vm.$set(_vm.job, "bookingRefuseNote", $$v)
                    },
                    expression: "job.bookingRefuseNote"
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section", staticStyle: { "min-width": "1600px" } },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ShippingInformation")))
          ]),
          _c(
            "div",
            {
              staticClass: "form-item-w260",
              staticStyle: { display: "flex", "flex-direction": "row" }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "110px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.Shipper") }
                    },
                    [
                      _c("cargo-company-select", {
                        class: _vm.isZh ? "shipper-input" : "shipper-input-en",
                        attrs: {
                          no: "28",
                          disabled: _vm.readonly,
                          "method-params": { shipper: true, active: true },
                          "default-value": _vm.job.shipperId || "",
                          placeholder: " ",
                          "static-options": _vm.hasChooseOwnTransceiverPermission
                            ? _vm.privateShipperList
                            : null
                        },
                        on: { change: _vm.shipperChange }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "29", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.billAddressDialog.visible = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, staticClass: "auto-width" },
                      [
                        _c("cargo-input", {
                          ref: "shipperLine" + i,
                          refInFor: true,
                          attrs: {
                            no: "30",
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.job,
                                "shipperLine" + i,
                                i + 1 > 7 ? null : "shipperLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Shipper"),
                                _vm.mergeShipperLine(),
                                _vm.splitShipperLine,
                                _vm.notUppercaseShipperConsigneNotify
                              )
                            }
                          },
                          model: {
                            value: _vm.job["shipperLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.job, "shipperLine" + i, $$v)
                            },
                            expression: "job['shipperLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfDeparture")))]
                      ),
                      _c("el-date-picker", {
                        attrs: {
                          no: "31",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: "",
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: { input: _vm.etdChange },
                        model: {
                          value: _vm.job.etd,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "etd", $$v)
                          },
                          expression: "job.etd"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_ArrivalTime") } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          no: "32",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.eta,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "eta", $$v)
                          },
                          expression: "job.eta"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PlaceOfReceipt") } },
                    [
                      _c("el-input", {
                        attrs: { no: "33" },
                        model: {
                          value: _vm.job.dispatchingPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "dispatchingPlace", $$v)
                          },
                          expression: "job.dispatchingPlace"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.LoadingPort")))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "short-el-input",
                          staticStyle: { width: "60px" },
                          attrs: { no: "34", disabled: true },
                          model: {
                            value: _vm.job.loadingPortCode,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "loadingPortCode", $$v)
                            },
                            expression: "job.loadingPortCode"
                          }
                        }),
                        _c("cargo-advance-select", {
                          staticClass: "port-item",
                          attrs: {
                            no: "35",
                            filterable: "",
                            "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                            "default-value": _vm.job.loadingPortCode,
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.loadingPortCode = p.value
                              _vm.onLoadingPortCodeChange()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.portOfDestination") } },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("Payment.portOfDestination")))]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "short-el-input",
                            staticStyle: { width: "60px" },
                            attrs: { no: "36", disabled: true },
                            model: {
                              value: _vm.job.destinationPortCode,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "destinationPortCode", $$v)
                              },
                              expression: "job.destinationPortCode"
                            }
                          }),
                          _c("cargo-advance-select", {
                            staticClass: "port-item",
                            attrs: {
                              no: "37",
                              filterable: "",
                              "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                              "default-value": _vm.job.destinationPortCode,
                              placeholder: _vm.$t("SeaExport.RequiredItem")
                            },
                            on: {
                              parentCallBack: _vm.destinationPortCodeChange
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c("el-form-item", { attrs: { label: " " } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "38" },
                            model: {
                              value: _vm.job.transfering,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "transfering", $$v)
                              },
                              expression: "job.transfering"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "39",
                              disabled: !_vm.job.transfering,
                              type: "primary"
                            },
                            on: { click: _vm.showTransitPortDialog }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.EnterTransitInfo")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.FinalPlaceOfDelivery") }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "40" },
                            on: {
                              input: function(val) {
                                return (_vm.job.destinationPlace = _vm.StrUtils.toUpperCase(
                                  val
                                ))
                              }
                            },
                            model: {
                              value: _vm.job.destinationPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "destinationPlace", $$v)
                              },
                              expression: "job.destinationPlace"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "41",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_CargoType,
                          "method-params": { air: true },
                          "default-value": _vm.job.cargoType,
                          clearable: false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.cargoType = p.value
                            _vm.onCargoTypeChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ArrivalMethod") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "42",
                          filterable: "",
                          "select-type":
                            _vm.TYPE_NAMES
                              .local_cache_AirExportConstants$SUFFY_TYPES,
                          "tag-name": _vm.isZh ? "chineseName" : "englishName",
                          "default-value": _vm.job.loadingTerm,
                          placeholder: _vm.$t("Message.PleaseSelect")
                        },
                        on: { parentCallBack: _vm.loadingTermChangeHandler }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_CargoTerminalOperation")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoTerminalOperation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_AirportCargoTerminal,
                          "method-params": { dataType: 0, deletionFlag: false },
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.job.cargoTerminalOperation
                        },
                        on: { parentCallBack: _vm.cargoTerminalOperationChange }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_EstimatedDeliveryDate")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          disabled:
                            _vm.readonly || !_vm.job.cargoTerminalOperation,
                          no: "estimatedDeliveryDate",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.estimatedDeliveryDate,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "estimatedDeliveryDate", $$v)
                          },
                          expression: "job.estimatedDeliveryDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("queryJob.masterBLFreightTerm") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "43",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_PaymentTerm,
                          "default-value": _vm.job.paymentTermMBL,
                          clearable: false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.paymentTermMBL = _vm.data.value
                            _vm.portChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.operateType !== 2,
                          expression: "job.operateType!==2"
                        }
                      ],
                      attrs: { label: _vm.$t("queryJob.HBLFreightClause") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "44",
                          "select-type": _vm.TYPE_NAMES.basic_data_PaymentTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.paymentTermHBL,
                          "allow-create": true
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.paymentTermHBL = p.value
                            _vm.portChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SolicitationType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "45",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.local_cache_CargoSource,
                          "default-value": _vm.job.cargoSource,
                          clearable: false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.cargoSource = p.value
                            _vm.selectFieldChangeHandler()
                            _vm.cargoSouceChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.job.cargoSource === "NC"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            id: "agentRefNo",
                            label: _vm.$t("SeaExport.NCReferenceNo")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "agentRefNo" },
                            model: {
                              value: _vm.job.agentRefNo,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "agentRefNo", $$v)
                              },
                              expression: "job.agentRefNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomJobType") } },
                    [
                      _c("cargo-advance-select", {
                        ref: "customJobType",
                        attrs: {
                          no: "46",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_CutomJobType,
                          "method-params": { type: _vm.job.lob, active: true },
                          "default-value": _vm.job.customJobType,
                          placeholder: _vm.$t("Message.PleaseSelect")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.customJobType = p.value
                            _vm.onCustomJobTypeChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.destinationAgent") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "47",
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          filterable: "",
                          "method-params": { overseaAgent: true, active: true },
                          "default-value": _vm.job.destinationAgent || "",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: _vm.txtDestinationAgentChangeHandler
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.cargoSource === "NC",
                          expression: "job.cargoSource==='NC'"
                        }
                      ]
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("queryJob.nominatedAgent")))]
                      ),
                      _c("cargo-company-select", {
                        attrs: {
                          no: "48",
                          "method-params": {
                            designationAgent: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.job,
                          "default-value": _vm.job.designationAgent || "",
                          "tag-name": "englishName",
                          placeholder: " "
                        },
                        on: { change: _vm.txtDesignationAgentChangeHandler }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.bookingAgentVisible,
                          expression: "bookingAgentVisible"
                        }
                      ],
                      attrs: { label: _vm.$t("queryJob.bookingAgent") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "49",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "method-params": {
                            bookingAgent: true,
                            companyLob: "airExport",
                            active: true
                          },
                          "default-value": _vm.job.bookingAgent || "",
                          placeholder: " "
                        },
                        on: { parentCallBack: _vm.bookingAgentChangeHandler }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.AirlineCompany") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "50",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "method-params": { airCmp: true, active: true },
                          "default-value": _vm.job.carrierId || "",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.carrierId = p.value || 0
                            _vm.onCarrierIdChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Flight") } },
                    [
                      _c("el-input", {
                        attrs: { no: "51" },
                        on: { change: _vm.voyageFlightCheckHandler },
                        model: {
                          value: _vm.job.voyageFlight,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "voyageFlight", $$v)
                          },
                          expression: "job.voyageFlight"
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "130px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.Consignee") }
                    },
                    [
                      _c("cargo-company-select", {
                        class: _vm.isZh ? "shipper-input" : "shipper-input-en",
                        attrs: {
                          no: "52",
                          disabled: _vm.readonly,
                          "method-params": { consignee: true, active: true },
                          "default-value": _vm.job.consigneeId || "",
                          placeholder: " ",
                          "static-options": _vm.hasChooseOwnTransceiverPermission
                            ? _vm.privateConsigneeList
                            : null
                        },
                        on: { change: _vm.consigneeChange }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "53", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.billAddressDialog.visible = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, staticClass: "auto-width" },
                      [
                        _c("cargo-input", {
                          ref: "consigneeLine" + i,
                          refInFor: true,
                          attrs: {
                            no: "54",
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.job,
                                "consigneeLine" + i,
                                i + 1 > 7 ? null : "consigneeLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Consignee"),
                                _vm.mergeConsigneeLine(),
                                _vm.splitConsigneeLine,
                                _vm.notUppercaseShipperConsigneNotify
                              )
                            }
                          },
                          model: {
                            value: _vm.job["consigneeLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.job, "consigneeLine" + i, $$v)
                            },
                            expression: "job['consigneeLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: {
                        label: _vm.$t("SeaExport.CommissionedNumberOfPackages")
                      }
                    },
                    [
                      _c("auto-number-input", {
                        staticStyle: { width: "230px" },
                        attrs: { no: "55", precision: 0, min: 0 },
                        model: {
                          value: _vm.job.quantityContract,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "quantityContract", $$v)
                          },
                          expression: "job.quantityContract"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.openImperial,
                          expression: "openImperial"
                        }
                      ]
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: {
                            label:
                              _vm.$t("SeaExport.CommissionedGrossWeight") +
                              "(LB)"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                staticStyle: { width: "230px" },
                                attrs: {
                                  no: "weightContractImperial",
                                  precision: 3,
                                  min: 0
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.doWeightChangeHandler(true)
                                  }
                                },
                                model: {
                                  value: _vm.job.weightContractImperial,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "weightContractImperial",
                                      $$v
                                    )
                                  },
                                  expression: "job.weightContractImperial"
                                }
                              }),
                              _c(
                                "div",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v("LB")]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: {
                            label:
                              _vm.$t("SeaExport.CommissionedVolume") + "(CFT)"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                staticStyle: { width: "230px" },
                                attrs: {
                                  no: "cubAgeContractImperial",
                                  precision: 3,
                                  min: 0
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.doCuAgeChangeHandler(true)
                                  }
                                },
                                model: {
                                  value: _vm.job.cubAgeContractImperial,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "cubAgeContractImperial",
                                      $$v
                                    )
                                  },
                                  expression: "job.cubAgeContractImperial"
                                }
                              }),
                              _c(
                                "div",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v("CFT")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.openImperial,
                          expression: "!openImperial"
                        }
                      ]
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: {
                            label: _vm.$t("SeaExport.CommissionedGrossWeight")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                staticStyle: { width: "230px" },
                                attrs: { no: "56", precision: 3, min: 0 },
                                on: {
                                  change: function($event) {
                                    return _vm.doWeightChangeHandler(false)
                                  }
                                },
                                model: {
                                  value: _vm.job.weightContract,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "weightContract", $$v)
                                  },
                                  expression: "job.weightContract"
                                }
                              }),
                              _c(
                                "div",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v("KGS")]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: {
                            label: _vm.$t("SeaExport.CommissionedVolume")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                staticStyle: { width: "230px" },
                                attrs: { no: "57", precision: 3, min: 0 },
                                on: {
                                  change: function($event) {
                                    return _vm.doCuAgeChangeHandler(false)
                                  }
                                },
                                model: {
                                  value: _vm.job.cubageContract,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "cubageContract", $$v)
                                  },
                                  expression: "job.cubageContract"
                                }
                              }),
                              _c(
                                "div",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v("M³")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("queryJob.CommissionedDensity") }
                    },
                    [
                      _c("auto-number-input", {
                        staticStyle: { width: "230px" },
                        attrs: { no: "58", precision: 3, min: 0 },
                        model: {
                          value: _vm.job.densityContract,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "densityContract", $$v)
                          },
                          expression: "job.densityContract"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Package") } },
                    [
                      _c("cargo-packing-select", {
                        attrs: {
                          no: "59",
                          disabled: _vm.readonly,
                          "default-value": _vm.job.packing,
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.job.packing = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "short-item-input",
                          staticStyle: { width: "auto" }
                        },
                        [
                          _c("label", { staticStyle: { width: "115px" } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.pbProportion")))
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : "",
                              staticStyle: { "margin-left": "15px" }
                            },
                            [
                              _vm.splitBubbleCollectionFormat
                                ? _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        value: _vm.job.pbProportion || "",
                                        no: "60",
                                        clearable: "",
                                        filterable: !_vm.pbProportionCheck,
                                        "allow-create": !_vm.pbProportionCheck
                                      },
                                      on: {
                                        focus: _vm.onPbProportionFocus,
                                        input: function(val) {
                                          _vm.job.pbProportion = val
                                        }
                                      }
                                    },
                                    _vm._l(
                                      _vm.SPLIT_BUBBLE_COLLECT_ITEMS,
                                      function(item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: _vm.$getLangColumn(item),
                                            value: item.code
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : [
                                    _c("el-input-number", {
                                      staticStyle: { "margin-right": "0px" },
                                      attrs: {
                                        no: "60",
                                        "controls-position": "right",
                                        precision: 0,
                                        min: 0,
                                        max: 100
                                      },
                                      model: {
                                        value: _vm.job.pbProportion,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "pbProportion", $$v)
                                        },
                                        expression: "job.pbProportion"
                                      }
                                    }),
                                    _c("span", [_vm._v("%")])
                                  ]
                            ],
                            2
                          ),
                          _c("label", { staticStyle: { width: "64px" } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.pbProportion2")))
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _vm.splitBubbleCollectionFormat
                                ? _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        value: _vm.job.pbProportion2 || "",
                                        no: "61",
                                        clearable: "",
                                        filterable: !_vm.pbProportion2Check,
                                        "allow-create": !_vm.pbProportion2Check
                                      },
                                      on: {
                                        focus: _vm.onPbProportion2Focus,
                                        input: function(val) {
                                          _vm.job.pbProportion2 = val
                                        }
                                      }
                                    },
                                    _vm._l(
                                      _vm.SPLIT_BUBBLE_COLLECT_ITEMS,
                                      function(item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: _vm.$getLangColumn(item),
                                            value: item.code
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : [
                                    _c("el-input-number", {
                                      attrs: {
                                        no: "61",
                                        "controls-position": "right",
                                        precision: 0,
                                        min: 0,
                                        max: 100
                                      },
                                      model: {
                                        value: _vm.job.pbProportion2,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "pbProportion2",
                                            $$v
                                          )
                                        },
                                        expression: "job.pbProportion2"
                                      }
                                    }),
                                    _c("span", [_vm._v("%")])
                                  ]
                            ],
                            2
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "short-item-input",
                          staticStyle: { width: "auto" }
                        },
                        [
                          _c(
                            "label",
                            { style: { width: _vm.isZh ? "130px" : "90px" } },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Pieces")))]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: { no: "62", precision: 0, min: 0 },
                                model: {
                                  value: _vm.job.insideQuantity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "insideQuantity", $$v)
                                  },
                                  expression: "job.insideQuantity"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "label",
                            { style: { width: _vm.isZh ? "65px" : "105px" } },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.ChargedWeight")))]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.openImperial,
                                  expression: "openImperial"
                                }
                              ],
                              staticClass: "short-input short-input-disabled"
                            },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  no: "chargeWeightImperial",
                                  controls: false,
                                  precision: 3,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.job.chargeWeightImperial,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "chargeWeightImperial",
                                      $$v
                                    )
                                  },
                                  expression: "job.chargeWeightImperial"
                                }
                              }),
                              _c("span", [_vm._v("LB")])
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.openImperial,
                                  expression: "!openImperial"
                                }
                              ],
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  no: "63",
                                  controls: false,
                                  precision: 3
                                },
                                model: {
                                  value: _vm.job.chargeWeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "chargeWeight", $$v)
                                  },
                                  expression: "job.chargeWeight"
                                }
                              }),
                              _c("span", [_vm._v("M/T")])
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PiecesType") } },
                    [
                      _c("cargo-packing-select", {
                        attrs: {
                          no: "64",
                          disabled: _vm.readonly,
                          "default-value": _vm.job.insidePacking,
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.job.insidePacking = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Size") } },
                    [
                      _c("el-input", {
                        attrs: { no: "65", type: "textarea", rows: 3 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Size"),
                              _vm.job.measurements,
                              function(val) {
                                _vm.job.measurements = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.measurements,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "measurements", $$v)
                          },
                          expression: "job.measurements"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "CargoMsg.Cargo_FrontEndWarehouseOperation"
                        )
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "frontEndWarehouseOperation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_AirportCargoTerminal,
                          "method-params": { dataType: 1, deletionFlag: false },
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.job.frontEndWarehouseOperation
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.frontEndWarehouseOperation = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_EstimatedWarehousingTime")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          no: "66",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.estimatedDateOfWarehousinge,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.job,
                              "estimatedDateOfWarehousinge",
                              $$v
                            )
                          },
                          expression: "job.estimatedDateOfWarehousinge"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_EstimatedDeliveryTime")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          no: "67",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.estimatedDeliveryTime,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "estimatedDeliveryTime", $$v)
                          },
                          expression: "job.estimatedDeliveryTime"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TradeTerms") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "68",
                          "select-type": _vm.TYPE_NAMES.basic_data_IncoTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.incoTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.incoTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BookingProperty") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "69", clearable: false, size: "mini" },
                          model: {
                            value: _vm.job.bookingTerm,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "bookingTerm", $$v)
                            },
                            expression: "job.bookingTerm"
                          }
                        },
                        _vm._l(_vm.bookingTerms, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomsDeclarationWay")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "70",
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_AirExportConstants$CUSTOM_CLAIMS,
                          "default-value": _vm.job.customClaim,
                          "tag-name": _vm.isZh ? "chineseName" : "englishName",
                          fields: ["chineseName"]
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.customClaim = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  Number(_vm.job.customClaim) === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomsDeclarationType")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "71",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames
                                  .basic_data_CustomsDeclarationType,
                              "default-value": _vm.job.customsClaim2 || 0
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.customsClaim2 = p.value
                                _vm.job.customsDeclarationType = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "130px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.NotifyParty") }
                    },
                    [
                      _c("cargo-company-select", {
                        class: _vm.isZh ? "shipper-input" : "shipper-input-en",
                        attrs: {
                          no: "72",
                          disabled: _vm.readonly,
                          "method-params": { notify: true, active: true },
                          "default-value": _vm.job.notifyId || "",
                          placeholder: " ",
                          "static-options": _vm.hasChooseOwnTransceiverPermission
                            ? _vm.privateNotifyList
                            : null
                        },
                        on: { change: _vm.notifyChange }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "73", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.billAddressDialog.visible = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, staticClass: "auto-width" },
                      [
                        _c("cargo-input", {
                          ref: "notifyLine" + i,
                          refInFor: true,
                          attrs: {
                            no: "74",
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.job,
                                "notifyLine" + i,
                                i + 1 > 7 ? null : "notifyLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.NotifyParty"),
                                _vm.mergeNotifyLine(),
                                _vm.splitNotifyLine,
                                _vm.notUppercaseShipperConsigneNotify
                              )
                            }
                          },
                          model: {
                            value: _vm.job["notifyLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.job, "notifyLine" + i, $$v)
                            },
                            expression: "job['notifyLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ChineseDescriptionOfGoods")
                      }
                    },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: {
                          height: "65px",
                          "min-height": "65px",
                          flex: "1"
                        },
                        attrs: {
                          no: "75",
                          disabled: !_vm.isEdit,
                          "auto-half-word": false,
                          "auto-uppercase": false
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                              _vm.job.cargoChineseName,
                              function(val) {
                                _vm.job.cargoChineseName = val
                              },
                              true,
                              { autoUppercase: true }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.cargoChineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoChineseName", $$v)
                          },
                          expression: "job.cargoChineseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                      }
                    },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: {
                          height: "65px",
                          "min-height": "65px",
                          flex: "1"
                        },
                        attrs: {
                          no: "76",
                          "text-chars": 0,
                          "warning-count": -1,
                          disabled: !_vm.isEdit,
                          "auto-uppercase": _vm.isUppercaseByConfig
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                              _vm.job.cargoEnglishName,
                              function(val) {
                                _vm.job.cargoEnglishName = val
                              },
                              _vm.isUppercaseByConfig,
                              { autoUppercase: _vm.isUppercaseByConfig }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.cargoEnglishName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoEnglishName", $$v)
                          },
                          expression: "job.cargoEnglishName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Marks") } },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: {
                          height: "65px",
                          "min-height": "65px",
                          flex: "1"
                        },
                        attrs: {
                          no: "77",
                          "text-chars": 0,
                          "warning-count": -1,
                          disabled: !_vm.isEdit,
                          "auto-uppercase": _vm.isUppercaseByConfig
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Marks"),
                              _vm.job.mark,
                              function(val) {
                                _vm.job.mark = val
                              },
                              _vm.isUppercaseByConfig,
                              { autoUppercase: _vm.isUppercaseByConfig }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.mark,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "mark", $$v)
                          },
                          expression: "job.mark"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CategoryOfGoods") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "78",
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_CargoInformation,
                          filterable: "",
                          "callback-params": { key: "cargoCode" },
                          "default-value": _vm.job.cargoCode,
                          placeholder: _vm.$t(
                            "queryJob.ClickSelectTheGoodsCode"
                          )
                        },
                        on: {
                          parentCallBack: _vm.txtCargoInformationChangeHandler
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { no: "79", disabled: !_vm.job.cargoCode },
                        model: {
                          value: _vm.job.cargoName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoName", $$v)
                          },
                          expression: "job.cargoName"
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.isSalesForSzfs
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.HaulageCompany") }
                        },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              no: "80",
                              disabled: !_vm.job.landTransportation,
                              "method-params": { truckCmp: true, active: true },
                              "default-value": _vm.job.carryingCmp || "",
                              placeholder: _vm.$t(
                                "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                              )
                            },
                            on: { change: _vm.carryingCmpChangeHandler }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SellingPrice") } },
                    [
                      _c("el-input", {
                        attrs: { no: "81" },
                        on: { blur: _vm.sellingOrBuyingChangeHandler },
                        model: {
                          value: _vm.job.selling,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "selling", $$v)
                          },
                          expression: "job.selling"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BuyingPrice") } },
                    [
                      _c("el-input", {
                        attrs: { no: "82" },
                        on: { blur: _vm.sellingOrBuyingChangeHandler },
                        model: {
                          value: _vm.job.buying,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "buying", $$v)
                          },
                          expression: "job.buying"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.loadingTerm === "DD",
                          expression: "job.loadingTerm==='DD'"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.Door") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "83",
                            "value-key": "name",
                            clearable: "",
                            filterable: "",
                            "allow-create": true
                          },
                          on: { change: _vm.doorsChangeHandler },
                          model: {
                            value: _vm.truckingInfo.doorName,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "doorName", $$v)
                            },
                            expression: "truckingInfo.doorName"
                          }
                        },
                        _vm._l(_vm.doorList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.name }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.loadingTerm === "DD",
                          expression: "job.loadingTerm==='DD'"
                        }
                      ],
                      attrs: { label: _vm.$t("Payment.contactPerson") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            staticClass: "short-el-input",
                            attrs: {
                              no: "84",
                              placeholder: _vm.$t("Payment.contactPerson")
                            },
                            model: {
                              value: _vm.truckingInfo.doorMan,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "doorMan", $$v)
                              },
                              expression: "truckingInfo.doorMan"
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "65px",
                                padding: "0 10px",
                                "font-size": "12px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Tel")))]
                          ),
                          _c("el-input", {
                            staticClass: "short-el-input",
                            attrs: {
                              no: "85",
                              placeholder: _vm.$t("SeaExport.Tel")
                            },
                            model: {
                              value: _vm.truckingInfo.doorManTel,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "doorManTel", $$v)
                              },
                              expression: "truckingInfo.doorManTel"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.loadingTerm === "DD",
                          expression: "job.loadingTerm==='DD'"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.DoorAddress") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "86", type: "textarea", rows: 3 },
                        model: {
                          value: _vm.truckingInfo.doorAddr,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "doorAddr", $$v)
                          },
                          expression: "truckingInfo.doorAddr"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.PortOfDestinationServices")
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: { no: "dischargingPortDoor" },
                          model: {
                            value: _vm.job.dischargingPortDoor,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "dischargingPortDoor", $$v)
                            },
                            expression: "job.dischargingPortDoor"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.DispatchVehiclesAtDestination")
                            ) + " "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: { no: "usCustomsClearance" },
                          model: {
                            value: _vm.job.usCustomsClearance,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "usCustomsClearance", $$v)
                            },
                            expression: "job.usCustomsClearance"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("queryJob.UsCustomsClearance")) + " "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BillExchangeAgent") } },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "exChangeAgent",
                          disabled: !_vm.job.dischargingPortDoor,
                          "method-params": { bookingAgent: true, active: true },
                          "default-value": _vm.job.exChangeAgent || ""
                        },
                        on: { change: _vm.onExChangeAgentChange }
                      })
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "100px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.SecondNotifyParty") }
                    },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: { width: "260px", height: "216px" },
                        attrs: {
                          no: "87",
                          disabled: _vm.readonly,
                          "text-chars": 0
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.SecondNotifyParty"),
                              _vm.job.alsoNotify,
                              function(val) {
                                _vm.job.alsoNotify = val
                              },
                              true,
                              { warningCount: 45, maxChar: 0 }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.alsoNotify,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "alsoNotify", $$v)
                          },
                          expression: "job.alsoNotify"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "auto-width" },
                    [
                      _c("special-requests-grid", {
                        ref: "selectedSpecialRequest",
                        attrs: {
                          no: "88",
                          "is-edit": _vm.isEdit,
                          "customer-id": _vm.job.customerId,
                          lob: _vm.job.lob,
                          job: _vm.job
                        },
                        model: {
                          value: _vm.job.satisfiedRequests,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "satisfiedRequests", $$v)
                          },
                          expression: "job.satisfiedRequests"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.Remarks") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "89", type: "textarea", rows: 4 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Remarks"),
                              _vm.job.remarks,
                              function(val) {
                                _vm.job.remarks = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "remarks", $$v)
                          },
                          expression: "job.remarks"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.UserDefinedField1") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "90", type: "textarea", rows: 4 },
                        model: {
                          value: _vm.job.userDefinedField1,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField1", $$v)
                          },
                          expression: "job.userDefinedField1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.UserDefinedField2") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "91", type: "textarea", rows: 4 },
                        model: {
                          value: _vm.job.userDefinedField2,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField2", $$v)
                          },
                          expression: "job.userDefinedField2"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.UserDefinedField3") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "92", type: "textarea", rows: 4 },
                        model: {
                          value: _vm.job.userDefinedField3,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField3", $$v)
                          },
                          expression: "job.userDefinedField3"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.UserDefinedField4") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "93", type: "textarea", rows: 4 },
                        model: {
                          value: _vm.job.userDefinedField4,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField4", $$v)
                          },
                          expression: "job.userDefinedField4"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "taxNature",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.job.taxNature,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "taxNature", $$v)
                            },
                            expression: "job.taxNature"
                          }
                        },
                        _vm._l(_vm.TAX_NATURES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("bill-address-dialog", {
        attrs: {
          visible: _vm.billAddressDialog.visible,
          job: _vm.job,
          "own-permission": _vm.hasChooseOwnTransceiverPermission,
          "customer-cmp-list": _vm.customerCmpList,
          "use-empty-customer-cmp-list": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.readonly,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "transit-port-dialog",
          attrs: {
            visible: _vm.transitPortDialog.visible,
            title: _vm.$t("SeaExport.TransitInformation"),
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.transitPortDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    "font-weight": "bold",
                    "text-align": "center"
                  },
                  attrs: { span: 10, offset: 4 }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.SecondCheck")))]
              ),
              _c(
                "el-col",
                {
                  staticStyle: {
                    "font-weight": "bold",
                    "text-align": "center"
                  },
                  attrs: { span: 10 }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.ThreeWay")))]
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "5px" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v("To")]),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "94",
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                      "default-value": _vm.transitPortDialog.form.secondPortCode
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.transitPortDialog.form.secondPortCode = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "95",
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                      "default-value": _vm.transitPortDialog.form.thirdPortCode
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.transitPortDialog.form.thirdPortCode = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v("By")]),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "96",
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "method-params": { airCmp: true },
                      "default-value":
                        _vm.transitPortDialog.form.secondCarrierId || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.transitPortDialog.form.secondCarrierIdd =
                          p.value || 0
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "97",
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "method-params": { airCmp: true },
                      "default-value":
                        _vm.transitPortDialog.form.thirdCarrierId || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.transitPortDialog.form.thirdCarrierId = p.value || 0
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v("Flight")]),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("el-input", {
                    attrs: { no: "98" },
                    model: {
                      value: _vm.transitPortDialog.form.secondFlight,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.transitPortDialog.form,
                          "secondFlight",
                          $$v
                        )
                      },
                      expression: "transitPortDialog.form.secondFlight"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("el-input", {
                    attrs: { no: "99" },
                    model: {
                      value: _vm.transitPortDialog.form.thirdFlight,
                      callback: function($$v) {
                        _vm.$set(_vm.transitPortDialog.form, "thirdFlight", $$v)
                      },
                      expression: "transitPortDialog.form.thirdFlight"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v("MAWB")]),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("el-input", {
                    attrs: { no: "100" },
                    model: {
                      value: _vm.transitPortDialog.form.secondMAWB,
                      callback: function($$v) {
                        _vm.$set(_vm.transitPortDialog.form, "secondMAWB", $$v)
                      },
                      expression: "transitPortDialog.form.secondMAWB"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("el-input", {
                    attrs: { no: "101" },
                    model: {
                      value: _vm.transitPortDialog.form.thirdMAWB,
                      callback: function($$v) {
                        _vm.$set(_vm.transitPortDialog.form, "thirdMAWB", $$v)
                      },
                      expression: "transitPortDialog.form.thirdMAWB"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "102", type: "primary" },
                  on: { click: _vm.confirmTransitPort }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "103" },
                  on: {
                    click: function($event) {
                      _vm.transitPortDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }